<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.81757 1C7.81757 0.447715 8.26528 0 8.81757 0C9.36985 0 9.81757 0.447715 9.81757 1L9.81756 1.0014L9.81757 11.2628L13.1108 7.96959C13.5013 7.57906 14.1345 7.57906 14.525 7.96959C14.9155 8.36011 14.9155 8.99328 14.525 9.3838L9.61589 14.2929L8.90879 15L8.20168 14.2929L3.29259 9.3838C2.90206 8.99328 2.90206 8.36011 3.29259 7.96959C3.68311 7.57907 4.31628 7.57907 4.7068 7.96959L7.81757 11.0804L7.81757 1ZM16 16H2V14C2 13.4477 1.55228 13 1 13C0.447715 13 0 13.4477 0 14V16V18H2H16H17H18V14C18 13.4477 17.5523 13 17 13C16.4477 13 16 13.4477 16 14V16Z"
            fill="currentColor"
        />
    </svg>
</template>
